<template>
  <div class="wrapper">
    <md-dialog-confirm
      :md-active.sync="is_display_remove_confirm"
      md-title="提示"
      md-content="确定要移除物品?"
      md-confirm-text="确定"
      md-cancel-text="取消"
      @md-cancel="onClickCancelRemove"
      @md-confirm="onClickConfirmRemove"
    />

    <md-dialog-alert :md-active.sync="show_alert" :md-content="alert_message" md-confirm-text="確定" />

    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("购物车") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <div class="md-small-hide md-xsmall-hide">
            <md-table>
              <md-table-row>
                <md-table-head>{{ $t("产品") }}</md-table-head>
                <md-table-head md-numeric>{{ $t("价钱") }}</md-table-head>
                <md-table-head class="cell-center">{{ $t("数量") }}</md-table-head>
                <md-table-head md-numeric>{{ $t("小计") }}</md-table-head>
              </md-table-row>

              <md-table-row v-for="(product, product_key) in display_products" :key="product_key">
                <md-table-cell>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-20 md-small-hide">
                      <img class="img-raised rounded" :src="product.image_url" />
                    </div>
                    <div class="md-layout-item md-xsmall-size-100">
                      <div class="md-headline">{{product.name_cn}}</div>
                    </div>
                  </div>
                </md-table-cell>
                <md-table-cell md-numeric>${{product.price}}</md-table-cell>
                <md-table-cell class="cell-center">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div class="container-flex_center">
                        <md-button
                          class="md-icon-button md-dense md-simple"
                          @click="onClickMinusQty(product)"
                        >
                          <md-icon>remove</md-icon>
                        </md-button>

                        <md-field md-inline>
                          <md-input
                            placeholder="1"
                            class="input-qty"
                            v-model="product.quantity"
                            @blur.native="updateCartQty(product)"
                          ></md-input>
                        </md-field>

                        <md-button
                          class="md-icon-button md-dense md-simple"
                          @click="onClickPlusQty(product)"
                        >
                          <md-icon>add</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </md-table-cell>
                <md-table-cell md-numeric>
                  <div class="container-numeric">
                    <div>${{product.sub_total}}</div>
                    <md-button
                      class="md-icon-button md-dense md-simple"
                      @click="onClickRemoveProduct(product)"
                    >
                      <md-icon>cancel</md-icon>
                    </md-button>
                  </div>
                </md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell colspan="3" md-numeric>{{ $t("总额") }}</md-table-cell>
                <md-table-cell>${{total_amount}}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>

          <div class="md-xlarge-hide md-large-hide md-medium-hide md-show-on-mobile">
            <md-card v-for="(product, product_key) in display_products" :key="product_key">
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item">{{ $t("产品") }}</div>
                  <div class="md-layout-item">
                    <div class>{{product.name_cn}}</div>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item">{{ $t("价钱") }}</div>
                  <div class="md-layout-item">${{product.price}}</div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item">{{ $t("数量") }}</div>
                  <div class="md-layout-item">
                    <div class="container-flex_center">
                      <md-button
                        class="md-icon-button md-dense md-simple"
                        @click="onClickMinusQty(product)"
                      >
                        <md-icon>remove</md-icon>
                      </md-button>

                      <md-field md-inline>
                        <md-input placeholder="1" class="input-qty" v-model="product.quantity"></md-input>
                      </md-field>

                      <md-button
                        class="md-icon-button md-dense md-simple"
                        @click="onClickPlusQty(product)"
                      >
                        <md-icon>add</md-icon>
                      </md-button>
                    </div>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item">{{ $t("小计") }}</div>
                  <div class="md-layout-item container-numeric">
                    <div>${{product.sub_total}}</div>
                    <md-button
                      class="md-icon-button md-dense md-simple"
                      @click="onClickRemoveProduct(product)"
                    >
                      <md-icon>cancel</md-icon>
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <div class="md-layout">
              <div class="md-layout-item" style="text-align: right;">{{ $t("总额") }}</div>
              <div class="md-layout-item">${{total_amount}}</div>
            </div>
          </div>

          <div class="container">
            <div class="md-layout md-gutter" v-if="products && products.length > 0">

              <div class="md-layout-item" style="text-align: right;">
                <router-link :to="{ name: 'checkout', params: {}}">
                  <md-button class="md-primary">{{ $t("前往结算") }}</md-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "cart",
  bodyClass: "cart-page",
  props: {},
  data() {
    return {
      products: [],
      selected_product: false,
      is_display_remove_confirm: false,
      show_alert: false,
      alert_message: ""
    };
  },
  methods: {
    verifyQty(product) {
      if (!this.$_.isInteger(parseFloat(product.quantity))) {
        this.alert_message = "請輸入數字";
        this.show_alert = true;
        return false;
      } else if (parseInt(product.quantity) <= 0) {
        this.alert_message = "數量不得少於0";
        this.show_alert = true;
        return false;
      }

      return true;
    },

    onClickPlusQty(product) {
      if (!this.$_.isInteger(parseFloat(product.quantity))) {
        product.quantity = 0;
      }
      product.quantity++;
      this.updateCartQty(product);
    },

    onClickMinusQty(product) {
      if (!this.$_.isInteger(parseFloat(product.quantity))) {
        product.quantity = 1;
      }

      if (product.quantity <= 1) {
        return;
      }
      product.quantity--;
      this.updateCartQty(product);
    },

    onClickRemoveProduct(product) {
      this.is_display_remove_confirm = true;
      this.selected_product = product;
    },

    onClickCancelRemove() {
      this.is_display_remove_confirm = false;
    },

    onClickConfirmRemove() {
      this.removeProduct(this.selected_product);
      this.is_display_remove_confirm = false;
    },

    async removeProduct(product) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_delete.php",
        data: {
          member_id: this.$store.state.member_id,
          cart_product_id: product.cart_product_id
        }
      });

      this.products = response.data.products;

      this.loader.hide();
    },

    async updateCartQty(product) {
      if (!this.verifyQty(product)) {
        return;
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_qty_update.php",
        data: {
          member_id: this.$store.state.member_id,
          product_id: product.id,
          quantity: product.quantity
        }
      });

      this.products = response.data.products;

      this.loader.hide();
    },

    async getCart() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_get.php",
        data: {
          member_id: this.$store.state.member_id
        }
      });

      this.products = response.data.products;

      this.loader.hide();
    }
  },
  computed: {
    total_amount() {
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      total_amount = this.$numeral(total_amount).format("0,0");

      return total_amount;
    },
    display_products() {
      return this.products.map(p => {
        p.sub_total = parseFloat(p.price) * parseFloat(p.quantity);
        p.price = this.$numeral(p.price).format("0,0");
        p.sub_total = this.$numeral(p.sub_total).format("0,0");
        return p;
      });
    },
  },
  async created() {
    await this.getCart();
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.img-product {
  height: 150px;
}

.md-field {
  min-width: 40%;
}
</style>